/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const IHEARTBERLIN: CommunityData = {
  code: "iheartberlin",
  inviteCode: "iheartberlin",
  name: "iHeartBerlin",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ihb-477`,
  socials: {},
  waitlist: false,
  styles: {
    comingSoon: {
      bgColor: "#111111",
      hero: {
        desktop: "https://media.werz.at/community-assets/iheartberlin/cs-landing-bg.mp4?type=video",
        mobile: "https://media.werz.at/community-assets/iheartberlin/cs-landing-bg.mp4?type=video",
        style: "bg-[#111111]",
      },
      logo: {
        desktop: "https://media.werz.at/community-assets/iheartberlin/logo-cs.png",
        mobile: "https://media.werz.at/community-assets/iheartberlin/logo-cs-mobile.png",
        style: "w-[140px] h-[131.06px] hidden sm:block",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['OpenSansSemiBold'] text-[28px] leading-[120%] text-[#aaef28]",
      text: "font-['OpenSansRegular'] text-[16px] leading-[120%] text-[#aaef28]",
      button:
        "font-['OpenSansSemiBold'] text-[14px] leading-[120%] p-4 rounded bg-[#aaef28] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['OpenSansRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#aaef28]",
        border: "#444444",
        borderFocus: "#aaef28",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#66960b]",
      skipButton:
        "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#66960b] cursor-pointer",
      socHideLogo: true,
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title: "font-['OpenSansSemiBold'] text-[24px] leading-[120%] text-[#aaef28] text-center",
        text: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#66960b] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#aaef28] bg-[#111111] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#aaef28",
      },
    },
    global: {
      mobileOnly: true,
      counterColor: "#aaef28",
      logo: {
        src: "https://media.werz.at/community/icon/cmgqjn56j00049k2qv9kmwy4e.jpg?uploadTime=1760520421824&type=image&v=1762238616236",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/iheartberlin/web-alternative-logo.png",
        styles: "w-[140px] h-[131.06px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#111111",
      asideBg: "#aaef28",
      asideStyles: "bg-[#aaef28] border-r border-transparent",
      contentBg: "#111111",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/iheartberlin/web-background.png",
      bgMobile: "https://media.werz.at/community-assets/iheartberlin/web-background-mobile.png",
      nonMemberBg:
        "https://media.werz.at/community-assets/iheartberlin/web-background-non-member.jpg",
      mainFont: "font-['OpenSansRegular']",
      primaryButton:
        "bg-[#aaef28] border-2 border-[#aaef28] rounded px-[18px] py-[18px] !text-[#000000] font-['OpenSansSemiBold'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "#000000",
      item: "text-[#000000] font-['OpenSansSemiBold'] text-[18px] text-center gap-x-[10px] text-opacity-50 border-b border-[#000000] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#111111] !pb-8 overflow-hidden border-transparent",
      titles: "text-[#aaef28] font-['OpenSansSemiBold'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#66960b] font-['OpenSansRegular'] text-[14px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#AAEF28]",
        sectionTitle:
          "text-[#aaef28] font-['OpenSansSemiBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-transparent",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#aaef28] font-['OpenSansSemiBold'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#66960b] font-['OpenSansRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#AAEF28]",
        sectionTitle:
          "text-[#aaef28] font-['OpenSansSemiBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-transparent",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#aaef28] font-['OpenSansSemiBold'] sm:text-[16px] text-left leading-[110%] mb-2",
          subtitle: "text-[#66960b] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
          location: "text-[#66960b] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
          date: "text-[#66960b] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#aaef28] font-['OpenSansSemiBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#aaef28] font-['OpenSansRegular'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#aaef28] font-['OpenSansSemiBold'] text-[26px] text-left leading-[110%] !mb-4 sm:!mb-4",
      },
    },
    linktree: {
      bgDesktop:
        "https://media.werz.at/community-assets/iheartberlin/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/iheartberlin/web-background-non-member.jpg",
      bgColor: "#111111",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#111111]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-transparent",
        name: "text-[#ffffff] font-['OpenSansSemiBold'] text-[26px] leading-[28.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#aaef28",
        button:
          "bg-[#222222] border border-[#aaef28] rounded px-4 py-3 text-[#aaef28] font-['OpenSansSemiBold'] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#111111] border border-transparent text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#111111] border border-transparent",
          title:
            "font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left text-center mb-1",
          text: "text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center text-center",
          button:
            "bg-[#222222] border border-[#aaef28] rounded px-4 py-3 text-[#aaef28] font-['OpenSansSemiBold'] text-[14px] text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#111111] border border-transparent",
          duration:
            "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
          name: "text-[#aaef28] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#aaef28",
          media: "overflow-hidden m-2 border border-transparent",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#111111] border border-transparent",
          name: "text-[#aaef28] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#aaef28] border border-[#aaef28] rounded-[4px] text-[#000000] font-['OpenSansSemiBold'] text-[16px] leading-[17.6px] text-center",
          duration:
            "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
          location:
            "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
          button:
            "bg-[#222222] border border-[#aaef28] rounded px-4 py-3 text-[#aaef28] font-['OpenSansSemiBold'] text-[14px] text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-transparent",
            name: "text-[#aaef28] font-['OpenSansSemiBold'] leading-[17.6px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#aaef28] font-['OpenSansSemiBold'] leading-[17.6px] text-[14px] text-left",
            link: "text-[#66960b] font-['OpenSansRegular'] text-[14px] leading-[18.2px] text-left",
            status: "text-[#aaef28] font-['OpenSansSemiBold'] leading-[110%] text-[14px] text-left",
            button:
              "bg-[#222222] border border-[#aaef28] rounded px-4 py-3 text-[#aaef28] font-['OpenSansSemiBold'] text-[14px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#111111] border border-transparent text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#111111] border border-transparent",
          name: "text-[#aaef28] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#aaef28",
          created: "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
          media: "overflow-hidden m-2 border border-transparent",
        },
        seeAllNews:
          "text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#111111] border border-transparent text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#111111] border border-transparent",
          coverUrl: "overflow-hidden m-2 border border-transparent",
          duration:
            "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
          liveType:
            "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#aaef28] rounded-full",
          playIconColor: "#aaef28",
          start: "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
          title:
            "text-[#aaef28] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#111111] border border-transparent text-[#aaef28] font-['OpenSansRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#111111] border border-transparent",
          name: "text-[#aaef28] font-['OpenSansSemiBold'] leading-[19.8px] text-[16px] text-left",
          triangleIconColor: "#aaef28",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-transparent",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#66960b] font-['OpenSansRegular'] text-[12px] leading-[15.6px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#111111] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#AAEF28]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#aaef28] font-['OpenSansSemiBold'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#66960b] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#aaef28] border-2 border-[#aaef28] rounded px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['OpenSansSemiBold'] text-[16px] text-left",
        questions: "text-[14px] text-left leading-[130%] text-[#66960b]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#AAEF28]",
        header: "text-[#aaef28] font-['OpenSansSemiBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#aaef28] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#AAEF28]",
        header: "text-[#aaef28] font-['OpenSansSemiBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#aaef28] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#aaef28] font-['OpenSansSemiBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#aaef28] font-['OpenSansRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#aaef28] font-['OpenSansSemiBold'] text-[26px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#111111] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#222222] border border-[#aaef28] rounded px-4 py-3 text-[#aaef28] font-['OpenSansSemiBold'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-transparent mb-4 overflow-hidden border-b border-transparent pb-4 border-b border-[#AAEF28]",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#aaef28] font-['OpenSansSemiBold'] text-[16px] text-left leading-[110%]",
          description:
            "text-[#66960b] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] !mt-1",
          price:
            "text-[#66960b] font-['OpenSansSemiBold'] text-[16px] text-left leading-[110%] !mt-1",
          quantity: "text-[#aaef28] font-['OpenSansSemiBold'] text-[14px] text-left",
          status: "text-[#66960b] font-['OpenSansSemiBold'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#222222] border border-[#aaef28] rounded !px-4 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#222222] border border-[#aaef28] rounded px-4 py-3 text-[#aaef28] font-['OpenSansSemiBold'] text-[14px] text-left !w-fit",
          plusMinusColor: "#aaef28",
        },
      },
    },
  },
}

export default IHEARTBERLIN
